import { auth } from "../libs/firebase";

export async function getHeaders() {
  const token = await auth.currentUser?.getIdToken();

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export default { getHeaders };
